import React from 'react';
import { Zap, Mail, MapPin, Phone } from 'lucide-react';

export default function Footer({ t }) {
  const f = t.footer;

  return (
    <footer className="bg-abyss border-t border-line">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <p className="text-xs text-mist/70 leading-relaxed max-w-5xl mx-auto text-center mb-12">
          {f.blurb}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
          <div className="flex flex-col gap-4 items-center md:items-start">
            <a href="/" className="flex items-center gap-2 select-none">
              <span className="w-8 h-8 rounded-lg bg-volt-400 flex items-center justify-center">
                <Zap size={17} strokeWidth={2.5} className="text-ink" fill="currentColor" />
              </span>
              <span className="font-display text-xl font-bold tracking-tight text-frost">
                Fit<span className="text-volt-400">upkeep</span>
              </span>
            </a>
            <p className="text-xs text-mist/70">{f.copyright}</p>
          </div>

          <nav className="flex flex-col items-center gap-3">
            {f.links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-mist hover:text-volt-400 transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex flex-col gap-3 items-center md:items-end text-center md:text-right">
            <span className="text-xs font-bold uppercase tracking-[0.18em] text-mist">
              {f.contactTitle}
            </span>
            <a
              href={`mailto:${f.email}`}
              className="inline-flex items-center gap-2 text-sm text-frost hover:text-volt-400 transition-colors duration-200"
            >
              <Mail size={15} className="text-volt-400" />
              {f.email}
            </a>
            <a
              href={`tel:${f.phone}`}
              className="inline-flex items-center gap-2 text-sm text-frost hover:text-volt-400 transition-colors duration-200"
            >
              <Phone size={15} className="text-volt-400" />
              {f.phone}
            </a>
            <p className="inline-flex items-start gap-2 text-sm text-mist">
              <MapPin size={15} className="text-volt-400 shrink-0 mt-0.5" />
              <span>
                {f.company}
                <br />
                {f.address}
              </span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
